import { render, staticRenderFns } from "./TypeWell.vue?vue&type=template&id=c4c945ca&scoped=true"
import script from "./TypeWell.vue?vue&type=script&lang=ts"
export * from "./TypeWell.vue?vue&type=script&lang=ts"
import style0 from "./TypeWell.vue?vue&type=style&index=0&id=c4c945ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c945ca",
  null
  
)

export default component.exports